import React from 'react';
import MessageListItem from '../message-list-item';
const MessageListItemComponent = ({ message, allMessages, index, companyEnrolements, me, form, }) => {
    return (<MessageListItem allMessages={allMessages} message={message} index={index} companyEnrolements={companyEnrolements} currentUser={me} form={form}/>);
};
export default MessageListItemComponent;
